var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticClass: "footer" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "footer__inner" }, [
          _c("div", { staticClass: "footer__menu" }, [
            _c(
              "div",
              [
                _c(
                  "router-link",
                  { staticClass: "footer__link", attrs: { to: "/details" } },
                  [_vm._v(" Avatar Upload Guide ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  { staticClass: "footer__link", attrs: { href: "#partners" } },
                  [_vm._v(" Partners ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  { staticClass: "footer__link", attrs: { to: "/faq" } },
                  [_vm._v("FAQ")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "footer__link impresum",
                    on: { click: _vm.modalOpen },
                  },
                  [_vm._v("Impressum")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "footer__link",
                    attrs: { to: "/privacy-policy", target: "_blank" },
                  },
                  [_vm._v(" Privacy Policy ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "footer__link",
                    attrs: { to: "/terms", target: "_blank" },
                  },
                  [_vm._v("Terms and Conditions")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "button hide-xs",
                    attrs: {
                      href: "mailto:info@anymecam.com?subject=Contact%20Us",
                    },
                  },
                  [_vm._v(" Contact Us ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("nav", { staticClass: "footer__socials" }, [
                _c(
                  "a",
                  {
                    staticClass: "soc-item",
                    attrs: { href: "https://x.com/AnymeCam", target: "_blank" },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticStyle: { "border-radius": "100%" },
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          version: "1.0",
                          width: "30",
                          height: "30",
                          viewBox: "0 0 126.000000 126.000000",
                          preserveAspectRatio: "xMidYMid meet",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              transform:
                                "translate(0.000000,126.000000) scale(0.100000,-0.100000)",
                              fill: "#000000",
                              stroke: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#fff",
                                d: "M125 1241 c-22 -10 -52 -31 -67 -47 -58 -62 -58 -62 -58 -566 0 -429 2 -466 19 -503 10 -22 31 -52 47 -67 62 -58 62 -58 566 -58 426 0 466 2 503 19 51 23 101 79 114 128 7 24 11 206 11 491 0 493 0 494 -58 556 -15 16 -45 37 -67 47 -37 17 -73 19 -505 19 -432 0 -468 -2 -505 -19z m466 -366 c42 -60 81 -111 87 -113 5 -1 54 49 108 112 94 110 101 116 137 116 l37 0 -120 -140 c-66 -77 -120 -144 -120 -149 0 -5 65 -101 145 -214 80 -114 145 -209 145 -212 0 -3 -53 -4 -117 -3 l-117 3 -91 129 c-50 72 -96 131 -101 133 -5 2 -61 -58 -124 -132 -110 -130 -116 -135 -153 -135 l-38 0 88 103 c49 56 112 129 140 163 l53 61 -135 191 c-74 105 -135 194 -135 197 0 3 53 4 117 3 l117 -3 77 -110z",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M421 883 c85 -124 372 -529 384 -541 7 -8 28 -12 53 -10 l41 3 -208 295 -208 295 -47 3 -48 3 33 -48z",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _vm._m(3),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer-apps" },
                [
                  _c("IosLink", { attrs: { mono: "" } }),
                  _vm._v(" "),
                  _c("AndroidLink", { attrs: { mono: "" } }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "button hide-lg",
                      attrs: {
                        href: "mailto:info@anymecam.com?subject=Contact%20Us",
                      },
                    },
                    [_vm._v(" Contact Us ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer__copy copy" }, [
        _vm._v(
          "Copyright © " +
            _vm._s(_vm.currentYear) +
            " Anyme Cam. All rights reserved."
        ),
      ]),
      _vm._v(" "),
      this.modalWindow
        ? _c("div", { staticClass: "modal" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "span",
                { staticClass: "close", on: { click: _vm.ModalClose } },
                [_vm._v("×")]
              ),
              _vm._v(" "),
              _c("h2", [_vm._v("Impressum")]),
              _vm._v(" "),
              _vm._m(4),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.cookie
        ? _c("Cookie", { on: { cookieClose: _vm.cookieClose } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "soc-item",
        attrs: {
          href: "https://www.facebook.com/share/1GgVz813yr/?mibextid=wwXIfr",
          target: "_blank",
        },
      },
      [
        _c("img", {
          attrs: {
            src: require("../../../public/img/social-media-facebook.png"),
            alt: "facebook",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "soc-item",
        attrs: {
          href: "https://www.linkedin.com/company/anyme-cam/",
          target: "_blank",
        },
      },
      [
        _c("img", {
          attrs: {
            src: require("../../../public/img/social-media-linkedin.png"),
            alt: "linkedin",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "soc-item",
        attrs: {
          href: "https://www.instagram.com/anyme_cam/?igsh=NGNycDZseGd0Y2kx&utm_source=qr",
          target: "_blank",
        },
      },
      [
        _c("img", {
          attrs: {
            src: require("../../../public/img/social-media-instagram.png"),
            alt: "instagram",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "soc-item",
        attrs: { href: "https://www.tiktok.com/@anymecam", target: "_blank" },
      },
      [
        _c("img", {
          attrs: {
            src: require("../../../public/img/social-media-tiktok.png"),
            alt: "tiktok",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gmbh" }, [
      _c("p", [_vm._v("Pixchange GmbH")]),
      _vm._v(" "),
      _c("p", [_vm._v("Spitalgasse 28, 3011 Bern, Switzerland.")]),
      _vm._v(" "),
      _c("p", [_vm._v("Contact: admin@anymecam.com")]),
      _vm._v(" "),
      _c("p", [_vm._v("Tax N°: CHE-482.794.880")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }